import { PureComponent } from 'react';

import Icons from 'Component/Icons';
import { getPluralPointsTranslation } from 'Util/Rewards';

import './RewardsPointsForProduct.style';
/** @namespace Pwa/Component/RewardsPointsForProduct/Component */
export class RewardsPointsForProduct extends PureComponent {
    renderContent() {
        const { productRewardPoints, isSignedIn } = this.props;
        if (!productRewardPoints || !isSignedIn) return null;

        return (
            <div block="RewardsPointsForProduct">
                <Icons name="coins" width="24" height="24" />
                <p>
                    {__('For this product you will receive')}
                    <span>{`${productRewardPoints} ${getPluralPointsTranslation(productRewardPoints)}`}</span>
                </p>
            </div>
        );
    }

    render() {
        return this.renderContent();
    }
}

export default RewardsPointsForProduct;
